import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "../main/nav";
import Footer from "../main/footer";
import ImportHeader from "../main/ImportHeader";
import axios from "axios";
import Swal from "sweetalert2";
import { formatToDateTime } from "../main/formatToDateTime";
import ImportGridView from "./ImportGridView";
export default function ImportCargo() {
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Type, setType] = useState("destuffing");

  useEffect(() => {
    GetData();
  }, [Type]);

  const GetData = async (page = 1) => {
    setLoading(true);
    try {
      let url = "";
      if (Type == "destuffing") {
        url = "https://ctas.live/backend/api/de_stuffing/live/data";
      }
      if (Type == "delivery") {
        url = "https://ctas.live/backend/api/delivery/live/data";
      }
      const response = await axios.get(url);

      if (response?.data?.status === "success") {
        const result = response.data.data;
        setData(result);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Oops!",
          text: "Something Went Wrong.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Fetch Error!",
        text: error.message || "Something went wrong while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };

  const [grid_data, setGrid_data] = useState([]);

  const fetchGridDetails = async (new_location_code) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://ctas.live/backend/api/import/map/data?name=Import&new_location_code=${new_location_code}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data?.data) {
        setGrid_data(response.data.data);
      } else {
        Swal.fire({
          icon: "info",
          text: "Something went wrong!",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error fetching data: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <ImportHeader />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              {/* Content */}
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row justify-content-between my-3">
                  <div className="col-md-12">
                    <h4>In Progress</h4>
                  </div>
                  <div className="col-md-12 d-flex gap-3 mb-4">
                    <button
                      className={
                        Type == "destuffing"
                          ? "btn btn-info"
                          : "btn btn-outline-info"
                      }
                      onClick={() => setType("destuffing")}
                    >
                      Destuffing
                    </button>
                    <button
                      className={
                        Type == "delivery"
                          ? "btn btn-info"
                          : "btn btn-outline-info"
                      }
                      onClick={() => setType("delivery")}
                    >
                      Delivery
                    </button>
                  </div>
                  <div className="col-md-12">
                    {Type == "destuffing" ? (
                      <div className="row align-items-center justify-content-between">
                        {Data && Data.length > 0 ? (
                          Data.map((item, index) => (
                            <div className="col-md-12 mb-6">
                              <div className="card">
                                <div className="card-body">
                                  <div className="col-md-12 mb-3">
                                    <div className="card border-primary border-1">
                                      <div className="card-body">
                                        <table className="table table-striped table-sm table-bordered table-hover">
                                          <thead>
                                            <tr>
                                              <th>SN.</th>
                                              <th>Type</th>
                                              <th>Container No</th>
                                              <th>Container Size</th>
                                              <th>Start Date Time</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr key={index}>
                                              <td>{index + 1}</td>
                                              <td>{item.type}</td>
                                              <td>{item.container_number}</td>
                                              <td>{item.container_size}</td>
                                              <td>
                                                {formatToDateTime(
                                                  item.start_time
                                                )}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row">
                                    {item?.de_stuffing_bill_details?.map(
                                      (details, i) => (
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-3">
                                          <div className="card border-primary border-1">
                                            <div className="card-body px-2">
                                              <table className="table table-sm mb-0">
                                                <tbody>
                                                  <tr>
                                                    <td>Bill Number</td>
                                                    <td>
                                                      <strong>
                                                        {details.bol_number ??
                                                          details.boe_number}
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Cargo Description</td>
                                                    <td>
                                                      <strong>
                                                        {
                                                          details.commodity_description
                                                        }
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>No of Pkgs</td>
                                                    <td>
                                                      <strong>
                                                        {
                                                          details.no_of_packages_declared
                                                        }
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Pkg Weight</td>
                                                    <td>
                                                      <strong>
                                                        {details.package_weight}
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>
                                                      Grid Location & Area
                                                    </td>
                                                    <td>
                                                      {details?.grid_area?.map(
                                                        (grid, k) => (
                                                          <p className="mb-0">
                                                            {
                                                              grid.grid_locations
                                                            }{" "}
                                                            / {grid.area ?? "0"}{" "}
                                                            <i
                                                              className="ri-eye-line ri-20px text-primary"
                                                              data-bs-toggle="modal"
                                                              data-bs-target="#gridView"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() =>
                                                                fetchGridDetails(
                                                                  grid.grid_locations
                                                                )
                                                              }
                                                            ></i>
                                                          </p>
                                                        )
                                                      )}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="card">
                            <div className="card-body">
                              <h4 className="text-center">No data available</h4>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="row align-items-center justify-content-between">
                        {Data && Data.length > 0 ? (
                          Data.map((item, index) => (
                            <div className="col-md-12 mb-6">
                              <div className="card">
                                <div className="card-body">
                                  <div className="col-md-12 mb-3">
                                    <div className="card border-primary border-1">
                                      <div className="card-body">
                                        <table className="table table-striped table-sm table-hover">
                                          <thead>
                                            <tr>
                                              <th>SN.</th>
                                              <th>GPM Number</th>
                                              <th>Container No</th>
                                              <th>Container Size</th>
                                              <th>Start Date Time</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr key={index}>
                                              <td>{index + 1}</td>
                                              <td>{item.gpm_number}</td>
                                              <td>{item.container_number}</td>
                                              <td>{item.container_size}</td>
                                              <td>
                                                {formatToDateTime(
                                                  item.start_time
                                                )}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row">
                                    {item?.delivery_trucks?.map(
                                      (details, i) => (
                                        <div className="col-md-4 col-sm-6 mb-3">
                                          <div className="card border-primary border-1">
                                            <div className="card-body px-2">
                                              <table className="table table-sm mb-0">
                                                <tbody>
                                                  <tr>
                                                    <td>Bill Number</td>
                                                    <td>
                                                      <strong>
                                                        {details.boe}
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Cargo Description</td>
                                                    <td>
                                                      <strong>
                                                        {
                                                          details.cargo_description
                                                        }
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>No of Pkgs</td>
                                                    <td>
                                                      <strong>
                                                        {details.no_of_pkgs}
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Pkg Weight</td>
                                                    <td>
                                                      <strong>
                                                        {details.pkgs_weight}
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>
                                                      Grid Location & Area
                                                    </td>
                                                    <td>
                                                      <strong>
                                                        {details?.grid_area?.map(
                                                          (grid, k) => {
                                                            if (
                                                              grid.grid_locations
                                                            ) {
                                                              return (
                                                                <p className="mb-0">
                                                                  {
                                                                    grid.grid_locations
                                                                  }{" "}
                                                                  / {grid.area}{" "}<i
                                                              className="ri-eye-line ri-20px text-primary"
                                                              data-bs-toggle="modal"
                                                              data-bs-target="#gridView"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() =>
                                                                fetchGridDetails(
                                                                  grid.grid_locations
                                                                )
                                                              }
                                                            ></i>
                                                                </p>
                                                              );
                                                            }
                                                          }
                                                        )}
                                                      </strong>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="card">
                            <div className="card-body">
                              <h4 className="text-center">No data available</h4>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="gridView"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-3 bg-label-primary">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Grid Details
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setGrid_data(null)}
              />
            </div>
            <div className="modal-body">
              {grid_data && grid_data?.[0]?.id && (
                <ImportGridView data={grid_data?.[0]} />
              )}
            </div>
            <div className="modal-footer py-3 bg-label-primary">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setGrid_data(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
